var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOthr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.7502H4.875C6.11251 21.7502 7.125 20.7377 7.125 19.5002V12.8252C7.125 11.5802 6.11251 10.5752 4.875 10.5752H3C1.76249 10.5752 0.75 11.5802 0.75 12.8252V19.5002C0.75 20.7377 1.76249 21.7502 3 21.7502Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 6.4126H11.0625C9.82499 6.4126 8.8125 7.42508 8.8125 8.6626V19.5001C8.8125 20.7376 9.82499 21.7501 11.0625 21.7501H12.9375C14.175 21.7501 15.1875 20.7376 15.1875 19.5001V8.6626C15.1875 7.42508 14.175 6.4126 12.9375 6.4126Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 2.25H19.125C17.8875 2.25 16.875 3.26249 16.875 4.5V19.5C16.875 20.7375 17.8875 21.75 19.125 21.75H21C22.2375 21.75 23.25 20.7375 23.25 19.5V4.5C23.25 3.26249 22.2375 2.25 21 2.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthr);
export default __webpack_public_path__ + "static/media/OTHR.b1faf45a35325bf7357ed1e397c36d9e.svg";
export { ForwardRef as ReactComponent };